var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"4","width":"18","height":"18","rx":"2","ry":"2","key":0}),React.createElement("line",{"x1":"16","y1":"2","x2":"16","y2":"6","key":1}),React.createElement("line",{"x1":"8","y1":"2","x2":"8","y2":"6","key":2}),React.createElement("line",{"x1":"3","y1":"10","x2":"21","y2":"10","key":3})]);
}

Calendar.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-calendar"};

module.exports = Calendar;

Calendar.default = Calendar;
